import { DOCUMENTATION_ROUTE } from "app/constants/route";

export const headCardModalAlertMobile = {
  title: '📢 Important: Use a Tablet or Laptop for the Best Experience',
  message: 'For the best experience, please access and complete your mock exam using a tablet or laptop. Some features may not work properly on a mobile phone.',
  description: 'Need Help? Check the guidelines for full instructions.',
  href: DOCUMENTATION_ROUTE
}